import reverbEdit from "./edit.vue";
import reverbList from "./list.vue";
import reverbInfo from "./info.vue";
import reverbBoundList from "./reverbBoundList.vue";
let a = Object.assign({ reverbList, reverbEdit, reverbInfo, reverbBoundList });
export default a;
